module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/store_images/5_756a88c10193acd8471fd7378b26f099.png";